import { Filter } from "@/models/Pageable"

export const accountPeriods = ["ALL", "LAST_7_DAYS", "LAST_30_DAYS", "LAST_90_DAYS", "LAST_YEAR"]

export type AccountPeriod = (typeof accountPeriods)[number]

export class FilterAccount extends Filter {
  q: string
  disabled: boolean
  test?: boolean | null
  dateRange?: AccountPeriod
  /** When true, only accounts with at least one AI request are returned (AI activity log filter). */
  hasAiRequests?: boolean
  constructor(props) {
    super(props)

    this.q = props.q ?? ""
    this.disabled = props.disabled ?? false
    this.dateRange = props.dateRange
    this.test = props.test
    this.hasAiRequests = props.hasAiRequests
  }

  getJsonObj() {
    const data = {
      q: this.q,
      enabled: !this.disabled,
      test: this.test,
      dateRange: this.dateRange,
      hasAiRequests: this.hasAiRequests
    }

    return super.getJsonObj({ params: data })
  }

  static create(props) {
    return new FilterAccount(props)
  }

  static createDefault() {
    const props = {
      q: "",
      disabled: false
    }

    return new FilterAccount(props)
  }
}

export class FilterDemoAccount extends Filter {
  q = ""
  dateRange?: AccountPeriod
  deleted = false

  constructor(props?: Partial<FilterDemoAccount>) {
    super(props as Filter)
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }

  getJsonObj() {
    const data = {
      q: this.q,
      dateRange: this.dateRange,
      deleted: this.deleted
    }

    return super.getJsonObj({ params: data })
  }
}
